<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/myAccountList/">My Accounts</a></li>
      <li aria-current="page" class="breadcrumb-item active">Create Address</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Address</h2>
<!--
          <div class="row">
            <div class="col-md-4 required">
              <label class="control-label" for="addressType">Address Type</label>
              <div class="form-group">
                <input [(ngModel)]="addressType" [ngModelOptions]="{standalone: true}" class="form-control" disabled
                       id="addressType" type="text">
                <div [hidden]="!statusText6" class="invalid-feedback d-block shift-invalid-login" id="statusText6">
                  {{statusText6}}
                </div>
              </div>
            </div>
          </div>
-->
          <div class="row">
            <div class="col-md-4 required">
              <label class="control-label" for="address1">Address 1</label>
              <div class="form-group ">
                <input (blur)="typeAddress1()" [(ngModel)]="address1" [ngClass]="{'is-invalid':statusText1}"
                       [ngModelOptions]="{standalone: true}" class="form-control"
                       id="address1"
                       required type="text">
                <div [hidden]="!statusText1" class="invalid-feedback d-block shift-invalid-login" id="statusText1">
                  {{statusText1}}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label class="control-label" for="address2">Address 2</label>
              <div class="form-group">
                <input [(ngModel)]="address2" [ngModelOptions]="{standalone: true}" class="form-control" id="address2"
                       required type="text">
              </div>
            </div>
            <div class="col-md-4 required">
              <label class="control-label">City</label>
              <div class="form-group ">
                <ng-select (blur)="typeCity()" [(ngModel)]="city" [ngClass]="{'is-invalid':statusText3}"
                            [ngModelOptions]="{standalone: true}"
                            id="city" required type="text" [items]="citiesList" [addTag]="true" placeholder="City">
                </ng-select>
                <div [hidden]="!statusText3" class="invalid-feedback d-block shift-invalid-login" id="statusText3">
                  {{statusText3}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 required">
              <label class="control-label">State</label>
              <div class="form-group">
                <ng-select (blur)="typeState()" [(ngModel)]="state" [items]="statesList"
                           [ngClass]="{'is-invalid':statusText4}"
                           [ngClass]="{'service-error':statusText4}"
                           [ngModelOptions]="{standalone: true}"
                           id="State"
                           placeholder="State">
                </ng-select>

                <div [hidden]="!statusText4" class="invalid-feedback d-block shift-invalid-login" id="statusText4">
                  {{statusText4}}
                </div>
              </div>
            </div>
            <div class="col-md-4 required">
              <label class="control-label" for="accountZipAlt">Zip</label>
              <div class="form-group ">
                <input (blur)="typeZip()" [(ngModel)]="zip" [ngClass]="{'is-invalid':statusText5}"
                       [ngModelOptions]="{standalone: true}" class="form-control" id="accountZipAlt"
                       placeholder="Enter PinCode"
                       maxlength="6" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                       required type="text" (change)="changeCityAndState()">
                <div [hidden]="!statusText5" class="invalid-feedback d-block shift-invalid-login" id="statusText5">
                  {{statusText5}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col text-right">
      <button class="btn btn-cancel" routerLink="/admin/myAccountList" type="reset">Cancel</button>
      <button (click)="createAddress()" class="btn btn-orange ml-2" type="submit">Save</button>
    </div>
  </div>
</div>
